export enum States {
    ME = "me",
    NM = "nm",
    GA = "ga"
}